import { useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";

import { Agency } from "../../../utilities/interfaces/Agency";
import { Title } from '../../../utilities/interfaces/Title';
import { Chapter } from '../../../utilities/interfaces/Chapter';

import { getAllAgencies } from "../../../features/state/StateAgency-slice";
import { getAllTitles, getTitleByAgencyId, } from '../../../features/state/StateTitle-slice';
import { getChaptersByTitleId } from "../../../features/state/StateChapter-slice";

import { chapterHistoryApi } from "../../../utilities/api/chapterHistoryApi";

export const useChapterHistoryManagementController = () => {
    // #region Redux & State

    const agencies: Agency[] = useAppSelector((state) => state.agency.agencies);
    const agencyTitles: Title[] = useAppSelector((state) => state.titles.titleList);
    const titleChapters: Chapter[] = useAppSelector((state) => state.chapters.chapters);

    const [selectedAgency, setSelectedAgency] = useState<any>();
    const [selectedTitle, setSelectedTitle] = useState<any>();
    const [selectedChapter, setSelectedChapter] = useState<any>();
    const [chapterHistory, setChapterHistory] = useState<any>();

    const [titlesAreLoading, setTitlesAreLoading] = useState<boolean>(false);
    const [chaptersAreLoading, setChaptersAreLoading] = useState<boolean>(false);
    const [chapterHistoryIsLoading, setChapterHistoryIsLoading] = useState<boolean>(false);

    const dispatch = useAppDispatch();

    // #endregion

    // #region Functions

    const handleAgencySelectChange = async (event: any) => {
        setSelectedAgency(event.value);
        setSelectedTitle(null);
        setSelectedChapter(null);

        setTitlesAreLoading(true);
        await dispatch(getTitleByAgencyId(event.value.id));
        setTitlesAreLoading(false);
    };

    const handleTitleSelectChange = async (event: any) => {
        setSelectedTitle(event.value);
        setSelectedChapter(null);

        setChaptersAreLoading(true);
        await dispatch(getChaptersByTitleId(event.value.id));
        setChaptersAreLoading(false);
    };

    const handleChapterSelectChange = async (event: any) => {
        setSelectedChapter(event.value);

        setChapterHistoryIsLoading(true);
        let chapterHistory = await chapterHistoryApi.getChapterHistoriesByChapterId(event.value.id);
        setChapterHistory(chapterHistory);
        setChapterHistoryIsLoading(false);
    }

    const reloadChapterHistory = async () => {
        setChapterHistoryIsLoading(true);
        let chapterHistory = await chapterHistoryApi.getChapterHistoriesByChapterId(selectedChapter.id);
        setChapterHistory(chapterHistory);
        setChapterHistoryIsLoading(false);
    }
    // #endregion

    return {
        // Functions
        handleAgencySelectChange,
        handleTitleSelectChange,
        handleChapterSelectChange,
        reloadChapterHistory,

        // Redux
        getAllAgencies,
        getAllTitles,

        // State
        agencies,
        agencyTitles,
        titleChapters,
        chapterHistory,
        selectedAgency,
        selectedTitle,
        selectedChapter,
        titlesAreLoading,
        chaptersAreLoading,
        chapterHistoryIsLoading,

        dispatch
    }
}